import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
import { EmailValidateService } from '../services/emailvalidate.service';
@Component({
    selector: 'app-emailvalidateaudit',
    templateUrl: './emailvalidateaudit.component.html',
    styleUrls: ['./emailvalidateaudit.component.css']
})
export class EmailValidateAuditComponent implements OnInit {
    displayedColumns = [
        'action',
        'email',
        'status',
        'api',
        'createdAt',
    ];
    fromDate;
    toDate;
    isToggled: boolean = false;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<emailValidateData>;
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private emailValidate: EmailValidateService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    displayProperJson(jsonData) {
        let obj = {
            jsonData: jsonData,
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.emailValidate.getEmailValidateAudit(this.filter).subscribe((success) => {
                let emailValidateRes = success.map(emailValidateAudit => {
                    emailValidateAudit.createdAt = moment(emailValidateAudit.createdAt).format('MM/DD/YY h:mm:ss A');
                    return emailValidateAudit;
                })
                this.dataSource = new MatTableDataSource(emailValidateRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const emailvalidateaudit = await this.dataSource.filteredData.map(x => ({
                "Email": x.email,
                "Status": x.status,
                "API": x.api,
                "Created At": x.createdAt,
            }));
            TableUtil.exportArrayToExcel(emailvalidateaudit, "emailvalidateaudit");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface emailValidateData {
    action: string,
    email: string,
    status: string,
    api: string,
    createdAt: string,
}


// WEBPACK FOOTER //
// ./src/app/emailvalidateaudit/emailvalidateaudit.component.ts